import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Text, Button, Checkbox } from '@beef/ui-kit';

import { formatPrice } from 'utils/formatting';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const FloatLayoutMobile = ({
  promotionAvailable,
  onSetIsChecked,
  isChecked,
  price,
  oldPrice,
  onBuyClick,
  buttonTitle,
  isInBasket,
}) => {
  const isBundle = !!promotionAvailable && !isInBasket && promotionAvailable?.salesNotes;
  return (
    <div className={cx('wrapper', isBundle && 'wrapper--with-border')}>
      {isBundle && (
        <div className={cx('wrapper-checkbox')}>
          <Checkbox
            label={promotionAvailable?.salesNotes}
            name="bundle"
            size="small"
            onChange={onSetIsChecked}
            checked={isChecked}
          />
        </div>
      )}
      <Button
        variant={isInBasket ? 'secondary' : undefined}
        onClick={onBuyClick}
        size="l"
        rightSideNode={
          <div className={cx('wrapper-price')}>
            {oldPrice && (
              <Text
                color={isInBasket ? 'grey50' : 'sienna'}
                isCrossedOut
                tagType="span"
                size="size5-r-l"
              >
                {`${formatPrice(oldPrice)} ₽`}
              </Text>
            )}
            <Text color={isInBasket ? 'white' : undefined} tagType="p" size="size4-r">
              {`${formatPrice(price)} ₽`}
            </Text>
          </div>
        }
      >
        {buttonTitle}
      </Button>
    </div>
  );
};

FloatLayoutMobile.propTypes = {
  price: PropTypes.number,
  oldPrice: PropTypes.number,
  onBuyClick: PropTypes.func,
  isChecked: PropTypes.bool,
  onSetIsChecked: PropTypes.func,
  buttonTitle: PropTypes.string,
  promotionAvailable: PropTypes.any,
  isInBasket: PropTypes.bool,
};
